import React from "react";
import styles from "./TextField.module.scss";
import classNames from "classnames";
import ValidationIcon from "../VlidationIcon/ValidationIcon";

export interface TextFieldProps {
  type?: "text" | "password" | "email" | "number";
  value?: string | number;
  placeholder?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  style?: React.CSSProperties;
  size?: "small" | "normal" | "large";
  valid?: boolean;
  label?: string;
}

const TextField: React.FC<TextFieldProps & React.ComponentProps<"input">> = ({
  type,
  value,
  placeholder,
  onChange,
  style,
  size = "normal",
  label,
  valid,
  ...restProps
}) => {
  return (
    <div className="flex flex-col gap-2">
      {label && <div className={styles.label}>{label}</div>}
      <div
        className={classNames(styles.baseContainer, styles[size])}
        style={style}
      >
        <input
          {...restProps}
          className={styles.input}
          type={type}
          value={value}
          placeholder={placeholder}
          onChange={onChange}
        />
      </div>
      {valid !== undefined && (
        <div className="relative">
          <div className="absolute -right-8 bottom-6 flex items-center pr-3">
            <ValidationIcon valid={valid} />
          </div>
        </div>
      )}
    </div>
  );
};

export default TextField;
